import React, { useCallback } from 'react';
import debounce from 'lodash.debounce';

import { CustomTable } from 'common/components/table/table';
import TableLoader from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/loader/table-loader';

import HeaderComponent from './HeaderComponent';

import { TABLE_HEADERS } from '../../constants';

import './index.scss';
import { Notification } from 'featureLib/NotificationComponent';
import { prepareSortModel } from 'common/components/table/table.constant';
import { IS_MULTIPLE_SORT, paginationLength } from 'rateCard/constant/constant';

const MainPanel = ({ tableData, loader, notification, setNotification, records, fetchOrderDetails }) => {
  const totalSites = tableData?.length;

  const fetchRecordsFn = ({ sortModel = {}, page = 1, size = 10 }) => {
    const params = {
      page: page - 1,
      size,
      ...sortModel
    };

    fetchOrderDetails(params);
  };

  const fetchRecords = useCallback(debounce(fetchRecordsFn, 100), []);

  const onTableStateChange = ({ sort, currentPage, showRows, activeColumn }) => {
    fetchRecords({ sortModel: prepareSortModel(sort, activeColumn, IS_MULTIPLE_SORT), page: currentPage, size: showRows });
  };

  const onClearFilter = ({ setShowRows, setCurrentPage }) => {};

  const onCellClickHandler = ({ rowData, headerConfig }) => {};
  return (
    <div className="main_panel mainpanel-container">
      <Notification
        onCancel={() => setNotification({ show: false, hideNotificaton: true })}
        show={notification.show && !notification.hideNotificaton}
        type={notification.type}
        message={notification.message}
        eventHandler={() => {}}
      />
      <div className={`card ${records && records.customerSegment ? records.customerSegment : ''}`}>
        <HeaderComponent totalSites={totalSites} />
        <CustomTable
          hideClearFilter
          loader={<TableLoader />}
          renderHeaderSection={() => {}}
          showLoader={loader}
          headers={TABLE_HEADERS}
          contents={tableData}
          onCellClickHandler={onCellClickHandler}
          totalPages={records?.totalPages}
          totalRecords={records?.totalElement}
          onChange={onTableStateChange}
          showSearch={false}
          multipleSort={false}
          onClearFilter={onClearFilter}
          paginationLength={paginationLength}
          renderMessage={() => {}}
          onSortChange={() => {}}
          onPageChange={() => {}}
        />
      </div>
    </div>
  );
};

export default MainPanel;
